/**
 * Package version string.
 *
 * @docLink packages/discovery/concepts
 */
export const VERSION = "0.0.0";

// Asset Kind Registry (pluggable kind resolution)
export { AssetKindRegistry } from "./asset-kind-registry.js";

// Built-in providers
export {
  agentProvider,
  BUILTIN_PROVIDERS,
  connectorProvider,
  contractProvider,
  mcpServerProvider,
  personaProvider,
  presetProvider,
  promptProvider,
  rulesetProvider,
  skillProvider,
} from "./builtin-providers.js";
export type {
  AtomizationPolicy,
  DiscoveredAsset,
  DiscoveryOptions,
  DiscoveryResult,
} from "./discover.js";
// Discovery orchestrator
export {
  computeDeterministicHash,
  createDefaultRegistry,
  DEFAULT_ATOMIZATION_POLICY,
  discoverAssetsInTree,
} from "./discover.js";
// Author-shipped inventory discovery
export { discoverFromManifest } from "./discover-manifest.js";

// Atomization convention defaults (Step 2)
export { AGENT_COMPANION_DIRS, SKILL_COMPANION_DIRS } from "./atomization-conventions.js";

// Atomization reference lint (Step 1) + closure (Step 3)
export type {
  AssetFs,
  AssetReference,
  ClosureResult,
  ReferenceClass,
  ReferenceWarning,
} from "./reference-lint.js";
export {
  closeOverReferences,
  createNodeAssetFs,
  extractPathCandidates,
  extractSlashCommands,
  lintUncoveredReferences,
  scanAssetReferences,
  scanSlashCommandNames,
} from "./reference-lint.js";

// Domains (navigational grouping from sidecar DOMAIN.md)
export {
  DOMAIN_MD_FILENAME,
  isDomainMdPath,
  parseDomainMd,
  validateDomains,
  assignDomain,
  buildDomainIndex,
} from "./domains.js";

export type {
  DomainRelation,
  DomainMember,
  DomainMd,
  DomainIndexEntry,
  DomainValidationError,
  DomainAssignable,
} from "./domains.js";

// Hash helpers
export { computeDeterministicHashDetailed } from "./hash.js";
export type { RequiresEdge, RequiresGraph } from "./requires-graph.js";
// Requires graph
export {
  buildRequiresGraph,
  detectCycles,
  extractRequires,
} from "./requires-graph.js";
export type {
  AssetEntry,
  MergedSourceConfig,
  PublisherOverride,
  SourceConfig,
  SourceConfigV2,
  SyncConfig,
  ValidationFailure,
  ValidationResult,
  ValidationSuccess,
} from "./source-config.js";
// Source config (internal IR, adapted from skaile.manifest.yaml)
export {
  barePublisher,
  decodeManifestSourceConfig,
  isExcludedDevPath,
  isManifestMode,
  loadMergedSourceConfig,
  loadMergedSourceConfigFromFile,
  loadSourceConfig,
  manifestToSourceConfig,
  mergeSourceConfigs,
  parseSourceConfig,
  readManifestSourceConfig,
  SEMVER_RE,
  SourceConfigSchema,
  validateSourceConfig,
} from "./source-config.js";
export type {
  DiscoverAssetsInTreeEntriesOptions,
  TreeEntry,
} from "./tree-entries.js";
// Discovery over a virtual tree (Octokit Tree entries)
export { discoverAssetsInTreeEntries } from "./tree-entries.js";
